"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AirplaneSVG = exports.AirplaneLargeSVG = void 0;
var AirplaneLargeSVG_1 = require("./AirplaneLargeSVG");
Object.defineProperty(exports, "AirplaneLargeSVG", { enumerable: true, get: function () { return __importDefault(AirplaneLargeSVG_1).default; } });
var AirplaneSVG_1 = require("./AirplaneSVG");
Object.defineProperty(exports, "AirplaneSVG", { enumerable: true, get: function () { return __importDefault(AirplaneSVG_1).default; } });
